/**
 * @zod
 * This is name exported for zod schema conversion to work
 * Frequency of measurements or data.
 * e.g Display data of a month per days (Time Step)
 */
export var TimeSteps;
(function (TimeSteps) {
    TimeSteps["perQuarterHours"] = "15T";
    /** Per half hours */
    TimeSteps["perHalfHours"] = "30T";
    /** Per hours */
    TimeSteps["perHours"] = "1H";
    /** every 2 hours (may be removed with additionalAggregates)  */
    TimeSteps["per2Hours"] = "2H";
    /** every 3 hours (may be removed with additionalAggregates) */
    TimeSteps["per3Hours"] = "3H";
    /** every 4 hours */
    TimeSteps["per4Hours"] = "4H";
    /** every 6 hours */
    TimeSteps["per6Hours"] = "6H";
    /** every 8 hours (may be removed with additionalAggregates) */
    TimeSteps["per8Hours"] = "8H";
    /** every 12 hours (may be removed with additionalAggregates) */
    TimeSteps["per12Hours"] = "12H";
    /** Per days */
    TimeSteps["perDays"] = "1D";
    /** Per weeks */
    TimeSteps["perWeek"] = "7D";
    /** Per months */
    TimeSteps["perMonth"] = "1M";
    /** Per 3 months */
    TimeSteps["perTrimester"] = "3M";
    /** 6 hours span */
    TimeSteps["perYears"] = "1Y";
    /** custom */
    TimeSteps["custom"] = "C";
    /** maximum frequency of the data source (15 minutes;) */
    TimeSteps["maximum"] = "MAX";
})(TimeSteps || (TimeSteps = {}));
export const underDayTimeSteps = [
    TimeSteps.maximum,
    TimeSteps.perQuarterHours,
    TimeSteps.perHalfHours,
    TimeSteps.perHours,
    /** may be removed with additionalAggregates */
    TimeSteps.per2Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per3Hours,
    TimeSteps.per4Hours,
    TimeSteps.per6Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per8Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per12Hours
];
/**
 * List of all available time steps - chronologically sorted
 * The sort order is essential since it's used to sort other lists
 */
export const allAvailableTimeSteps = [
    TimeSteps.maximum,
    TimeSteps.perQuarterHours,
    TimeSteps.perHalfHours,
    TimeSteps.perHours,
    /** may be removed with additionalAggregates */
    TimeSteps.per2Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per3Hours,
    TimeSteps.per4Hours,
    TimeSteps.per6Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per8Hours,
    /** may be removed with additionalAggregates */
    TimeSteps.per12Hours,
    TimeSteps.perDays,
    TimeSteps.perWeek,
    TimeSteps.perMonth,
    TimeSteps.perTrimester,
    TimeSteps.perYears,
    TimeSteps.custom
];
export default TimeSteps;
